import React from 'react'
import COLORS from '../styles/colors'
import { SVGProps } from '../types/svg'
import commonStyles from '../styles/globalStyles'

interface Props {
  onClick: (value: any) => void
  selected: any
  options: {
    text: string
    value: any
    Icon?: React.FC<SVGProps>
  }[]
}

const SwitchButton = (props: Props) => (
  <div style={styles.container}>
    {props.options.map((option) => {
      const isSelected = props.selected === option.value
      const { value, text, Icon } = option
      return (
        <button
          type='button'
          // @ts-ignore
          style={styles.optionButton(isSelected)}
          onClick={() => props.onClick(value)}
          value={value}
          key={value}
        >
          {Icon && <Icon color={isSelected ? COLORS.greyscale.white : COLORS.greyscale.dark} />}
          <p style={styles.text(isSelected)}>{text}</p>
        </button>
      )
    })}
  </div>
)

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginBottom: 20,
    boxShadow: commonStyles.general.shadow,
  },
  optionButton: (isSelected: boolean) => ({
    height: 72,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    border: 'none',
    backgroundColor: isSelected ? COLORS.brand.primaryDark : COLORS.lightGray,
    borderRadius: 2,
    cursor: 'pointer',
  }),
  text: (isSelected: boolean) => ({
    fontWeight: 700,
    fontSize: 16,
    color: isSelected ? COLORS.greyscale.white : COLORS.gray,
  }),
}

export default SwitchButton
